import { render, staticRenderFns } from "./project-properties.vue?vue&type=template&id=6f4c90ba"
import script from "./project-properties.vue?vue&type=script&lang=js"
export * from "./project-properties.vue?vue&type=script&lang=js"
import style0 from "./project-properties.vue?vue&type=style&index=0&id=6f4c90ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports